import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Image from '../Image/Image';

const ProductImage = (props) => {
  const { alt, className, image, showProductImage } = props;

  return showProductImage ? (
    <Image
      alt={alt}
      className={cn('o-media__image  c-product__image', className)}
      image={image}
    />
  ) : null;
};

export default ProductImage;

ProductImage.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  showProductImage: PropTypes.bool,
};

ProductImage.defaultProps = {
  className: '',
  showProductImage: true,
};
